import { peopleTypes } from '@/reports/types';

const serializeJobs = (jobs: peopleTypes.Job[]) => {
  return jobs
    .map((job) => {
      if (job?.period && job?.period?.start_date && job?.period?.end_date) {
        job.meta.first_seen_date = job.period.start_date;
        job.meta.last_seen_date = job.period.end_date;
      }

      return job;
    })
    .filter((job) => job?.company);
};

export { serializeJobs };
